// extracted by mini-css-extract-plugin
module.exports = {"sideBarSpacing":"LayoutWrapper_sideBarSpacing__2wIax","menuOpen":"LayoutWrapper_menuOpen__18_1Z","menuClosed":"LayoutWrapper_menuClosed__3m882"};